/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import {ShipmentCommonsAttachmentsUpdateDTO, ShipmentCommonsCmrUpdateDTO} from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShipmentAttachmentResourceService extends AbstractResourceService<any, any, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('shipmentAttachmentUrl'),
      undefined,
      undefined
    );
  }

  updateCMR(cmrUpdateModel: ShipmentCommonsCmrUpdateDTO): Observable<void> {
    return this.httpClient?.post(`${this.url}/cmr`, cmrUpdateModel)
      .pipe(this.getDtoMapper());
  }

  addAttachments(attachmentUpdateModel: ShipmentCommonsAttachmentsUpdateDTO): Observable<void> {
    return this.httpClient?.post(`${this.url}/attachments`, attachmentUpdateModel)
      .pipe(this.getDtoMapper());
  }
}
